import { fetchCompanyDetails as getCompanyDetails } from 'pricing-pages-lib/api/fetchCompanyDetails';
import { COMPANY_DETAILS } from './constants/RequestedDataTypes';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
import makeFetchRequest from './helpers/makeFetchRequest';
export const FetchCompanyDetailsRequestTypes = createRequestTypes(COMPANY_DETAILS);
export const FetchCompanyDetailsActions = createRequestActions(FetchCompanyDetailsRequestTypes);
export const fetchCompanyDetails = () => makeFetchRequest({
  requestActions: FetchCompanyDetailsActions,
  fetch: getCompanyDetails
});